import { render, staticRenderFns } from "./video-row.vue?vue&type=template&id=45658eb1&scoped=true"
import script from "./video-row.vue?vue&type=script&lang=js"
export * from "./video-row.vue?vue&type=script&lang=js"
import style0 from "./video-row.vue?vue&type=style&index=0&id=45658eb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45658eb1",
  null
  
)

export default component.exports